export default __webpack_public_path__ + "static/media/adria.7e7ca136.png";